<template>
  <div class="form">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div v-loading="loading">
      <div class="button_wrap">
        <span
          ><h4>{{ language("accountManagement.breadcrumbTitle") }}</h4></span
        >
        <el-button type="primary" @click="open">{{
          language("accountManagement.add")
        }}</el-button>
      </div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          {{ language("accountManagement.results") }} {{ results }}
          {{ language("accountManagement.rows") }}
        </div>
        <!-- <page :total="results" @pageChange="pageChange"></page> -->
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :dataArr="dataArr"
        :emptyText="language('accountManagement.emptyText')"
        :showIndex="false"
        :buttonsWidth="90"
      ></cc-table>

      <el-dialog
        :title="language('accountManagement.breadcrumbTitle')"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        width="80%"
      >
        <template v-if="dialog">
          <edit-management
            :objData="objData"
            @success="success"
          ></edit-management>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import editManagement from "./components/editManagement";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    editManagement,
    page,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("accountManagement.breadcrumbList_2"),
        list: [
          {
            name: this.language("accountManagement.breadcrumbList_1"),
          },
          {
            name: this.language("accountManagement.breadcrumbList_2"),
          },
        ],
      },
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "createtime",
            lable: this.language("accountManagement.createTime"),
            minWidth: 200,
          },
          // {
          //   prop: "updatedTime",
          //   lable: this.language("accountManagement.lastUpdated"),
          //   minWidth: 200,
          // },
          {
            prop: "email",
            lable: this.language("accountManagement.loginEmail"),
            minWidth: 230,
          },
          // {
          //   prop: "account",
          //   lable: this.language("accountManagement.loginUser"),
          //   minWidth: 230,
          // },
          {
            prop: "status",
            lable: this.language("accountManagement.status"),
            minWidth: 80,
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("accountManagement.online"),
              },
              2: {
                tagType: "danger",
                text: this.language("accountManagement.frozen"),
              },
              3: {
                tagType: "danger",
                text: this.language("accountManagement.delete"),
              },
            },
          },
          {
            prop: "expirydate",
            lable: this.language("accountManagement.expirydate"),
            minWidth: 100,
            render: (rows) => {
              if (rows.expirydate) {
                return rows.expirydate.split(" ")[0];
              }
              return "2099-12-31";
            },
          },
          {
            prop: "description",
            lable: this.language("accountManagement.description"),
            minWidth: 230,
          },
        ],
        buttons: [
          {
            name: this.language("accountManagement.edit"),
            click: (row, index) => {
              // 设置权限
              this.ccRequest
                .do("admin/merchant/user/getAccountDetail", { userId: row.id })
                .then((res) => {
                  let data = {
                    ...res,
                  };
                  if (data.expirydate) {
                    data.expirydateStr = data.expirydate.split(" ")[0];
                  }
                  this.objData = { ...data };
                  //主賬號限制一些字段填寫
                  if (row.parentId == 0) {
                    this.objData.disabled = true;
                    this.objData.expirydateStr="2099-12-31 00:00:00"
                  } else {
                    this.objData.disabled = false;
                  }
                  this.dialog = true;
                })
                .catch((err) => {
                  console.log(err);
                  this.$message.error(err.response.data.message);
                });
            },
            check: (row) => {
              if (row.parentId == 0) {
                if(this.isMainAcc){
                  return true
                }
                return false;
              } else {
                return true;
              }
            },
          },
        ],
      },
      params: {},
      refeshTable: -1,
      dialog: false,

      results: 0,
      dataArr: [],
      objData: {},
      isMainAcc:false
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.objData = {};
    },

    getData(e) {
      this.loading = true;
      e.merchantNum = this.shopData.merchantNum;
      this.ccRequest
        .do("admin/merchant/user/querySubAccountList", e)
        .then((res) => {
          this.dataArr = res;
          this.results = res.length;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    success() {
      this.dialog = false;
      this.getData({});
    },
    getIsMainAcc() {
      let e = {};
      e.merchantNum = this.shopData.merchantNum;
      this.ccRequest
        .do("admin/merchant/user/queryIsMainAcc", e)
        .then((res) => {
          this.isMainAcc=res
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    this.getData({});
    this.getIsMainAcc();
  },
};
</script>
<style scoped lang="scss">
.button_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  font-size: $sbuTitle;
  font-weight: 600;
}
</style>